export function getExerciseBlocks(exerciseData) {
  const getZone = (block) => {
    return block.fields.showInResults
      ? (block.fields.resultZonesNumbers ? block.fields.resultZonesNumbers.map(i => parseInt(i.col1)) : parseInt(block.fields.resultZoneNumber))
      : 0;
  };

  const getBlocks = (field) => {
    return Object.fromEntries(Object.values(field).flatMap(d => Object.entries(d.fields.exerciseBlocks)));
  };

  const blocks = [];
  for (let [key, block] of Object.entries(getBlocks(exerciseData))) {
    if (block.type === "columns") {
      for (let [key2, childBlock] of Object.entries(getBlocks(block.fields.exerciseColumns))) {
        blocks.push({
          id: key2,
          block: childBlock,
          showInResults: !!childBlock.fields.showInResults,
          zone: getZone(childBlock),
          resultOrder: childBlock.fields.resultOrder
        });
      }
    }
    blocks.push({
      id: key,
      block: block,
      showInResults: !!block.fields.showInResults,
      zone: getZone(block),
      resultOrder: block.fields.resultOrder
    });
  }
  return blocks;
}
